import React from "react";
import { Box, Stack, useMediaQuery } from "@mui/material";
import "./ButtonBar.scss";

type ButtonBarProps = {
    leftButtons?: React.ReactNode[],
    rightButtons?: React.ReactNode[]
}

const ButtonBar = (props: ButtonBarProps) => {
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const regularStyle = { padding: '8px' };
    const smallStyle = { padding: '8px', flex: 1, width: '100%' };

    return (
        <Stack
            direction={isSmall ? 'column' : 'row' }
            sx={{ marginBottom: '24px', borderRadius: '8px' }}
            className="button-bar">
            <Box sx={{ width: isSmall ? '100%' : '50%', margin: 'auto' }}>
                <Stack
                    direction={isSmall ? 'column' : 'row' }
                    className="button-bar-button"
                    justifyContent={"flex-start"}
                    sx={{ width: '100%' }}
                >
                    {props.leftButtons?.map((button, index) =>
                        <Box
                            key={`left-button-${index}`}
                            sx={isSmall ? smallStyle : regularStyle}
                        >
                            {button}
                        </Box>
                    )}
                </Stack>
            </Box>
            <Box sx={{ width: isSmall ? '100%' : '50%', margin: 'auto' }}>
                <Stack               
                    direction={isSmall ? 'column' : 'row' }
                    className="button-bar-button"
                    justifyContent={"flex-end"}
                    sx={{ width: '100%' }}
                >
                    {props.rightButtons?.map((button, index) =>
                        <Box
                            key={`right-button-${index}`}
                            sx={isSmall ? smallStyle : regularStyle}
                        >
                            {button}
                        </Box>
                    )}
                </Stack>
            </Box>
        </Stack>
    );
}

export default ButtonBar;